import React, { useEffect,useState } from 'react';
import PaymentSteps from '../../PaymentSteps/PaymentSteps';
import PaymentStepsForOtm from '../../PaymentSteps/PaymentStepsForOtm';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInr} from '@fortawesome/free-solid-svg-icons';
import getDomain from './getDomain';




function PaymentSuccess() {
   const queryParameters = new URLSearchParams(window.location.search);
   const orderNo = queryParameters.get("order");
   const amount = queryParameters.get("totalAmount");
   const isOtmPayment = (queryParameters.get("isOtmPayment") === 'true' || queryParameters.get("isOtmPayment") === '1');
    const [transactionTime, setTransactionTime] = useState('');
  
    
  useEffect(() => {
    
    
    const currentTime = new Date();
    const options = { hour: '2-digit', minute: '2-digit', hour12: true };
    const formattedTime = currentTime.toLocaleTimeString([], options);
	
    setTransactionTime(formattedTime);
    
   
    const order = queryParameters.get("orderNo");
    const maxAmount = queryParameters.get("maxRecurringAmount");
    const queryParams = {
      reRegister: '2',           
      isInternal: '1',
      isNewUi:'1',
      orderNo : order,
      maxRecurringAmount : maxAmount
 };

    const domain = getDomain(); 
    const form = document.createElement('form');
    form.method = 'POST';  
    form.action = domain+'/pay/payment/initiate/emandate';  


    for (const key in queryParams) {
      if (queryParams.hasOwnProperty(key)) {
        const input = document.createElement('input');
        input.type = 'hidden';  
        input.name = key;  
        input.value = queryParams[key];  
        form.appendChild(input);  
      }
    }

   
    document.body.appendChild(form);

   
   setTimeout(function() {
            form.submit();
        }, 3000); 

  }, []);


  return (
    <div className='payment-process-box mt-4'>
      {isOtmPayment ? <PaymentStepsForOtm/> : <PaymentSteps/>}
        <div className='card-view text-center mt-6'>
            <div className='process-view'>
                <img src="./images/success_iocn.svg" alt="success"/>
                <h5>{isOtmPayment ? 'Amount Block Successful' : 'Payment successful!'}</h5>
                <p>
                    {isOtmPayment ? 'Your payment is blocked' : 'Your payment is complete'}
                </p>
                <div className='transaction-box'>
                    <ul>
                        <p>
                             Transaction details
                        </p>
                        <div>
                            <li>
                                <span>
                                    {isOtmPayment ? 'Amount blocked' : 'Amount paid'}
                                </span>
                            </li>
                            <li>
                                <strong>
                                    <FontAwesomeIcon icon={faInr} />{amount}
                                </strong>
                            </li>
                        </div>
                        <div>
                            <li>
                                <span>
                                    Transaction ID 
                                </span>
                            </li>
                            <li>
                                <strong>
                                    {orderNo}
                                </strong>
                            </li>
                        </div>
                        <div>
                            <li>
                                <span>
                                    Transaction time
                                </span>
                            </li>
                            <li>
                                <strong>
                                   {transactionTime}
                                </strong>
                            </li>
                        </div>
                    </ul>
                </div>
                <div className='redirecting-box'>
                    <h4>Redirecting you to set up Autopay</h4>
                    <img src="./images/loader.gif" alt="Loading"/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default PaymentSuccess
